module.exports = __webpack_public_path__ + "static/img/storage.25313e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/storage.png
// module id = 4nx/
// module chunks = 1